import { create } from "zustand";

/**
 * useCadastroEpiListaFilters
 */

type State = {
  nome: string | null;
};

export const initialCadastroEpiListaState: State = {
  nome: null,
}

export const useCadastroEpiListaFilters = create<State>((set, get) => ({
  ...initialCadastroEpiListaState,
}));